import { useEffect, useState } from 'react';
import { useSearchParams } from 'next/navigation';
import { DEFAULT_SEARCH_PARAMS } from '@/constants/insights';
import { IFilterableItem, filterService } from '@/services/searchInsights';

interface IProps<T extends IFilterableItem> {
  list: T[];
  searchQuery?: string;
}

export const useFilter = <T extends IFilterableItem>({ list, searchQuery }: IProps<T>) => {
  const searchParams = useSearchParams();
  const [filteredList, setFilteredList] = useState<T[]>(list);

  useEffect(() => {
    let currentList = list;

    const tagsFromSearchParams = searchParams.get(DEFAULT_SEARCH_PARAMS.tags);
    const categoryFromSearchParams = searchParams.get(DEFAULT_SEARCH_PARAMS.category);

    if (tagsFromSearchParams) {
      currentList = filterService.filterByTags(tagsFromSearchParams, currentList);
    }

    if (categoryFromSearchParams) {
      currentList = filterService.filterByCategory(categoryFromSearchParams, currentList);
    }

    if (searchQuery) {
      currentList = filterService.searchByAllAttributes(searchQuery, currentList);
    }

    setFilteredList(currentList);
  }, [list, searchParams, searchQuery]);

  return filteredList;
};
